import React from 'react';
import ReactDOM from 'react-dom';
import Provider from './utils/Provider';

import store, { history } from './store';
import App from './App';
import '../src/index.css';
import * as serviceWorker from './serviceWorker';
import { Helmet } from 'react-helmet';

import CacheBuster from 'react-cache-buster';
import packageJson from '../package.json';
import { Box, CircularProgress, Typography } from '@material-ui/core';

const isProduction = process.env.NODE_ENV === 'production';

ReactDOM.render(
    <Provider store={store} history={history}>
        <React.StrictMode>
            <Helmet>
                <meta name="google" content="notranslate" />
                <link rel="icon" href="/favicon.png" />
            </Helmet>
            <CacheBuster
                currentVersion={packageJson.version}
                isEnabled={isProduction} // enable only in production
                isVerboseMode={false} // silence console logs
                loadingComponent={
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        flexDirection="column"
                        minHeight="100vh"
                    >
                        <CircularProgress />
                        <Typography variant="body1" sx={{ mt: 2 }}>
                            Cargando...
                        </Typography>
                    </Box>
                }
                metaFileDirectory={'.'} // meta.json is at /meta.json
            >
                <App />
            </CacheBuster>
        </React.StrictMode>
    </Provider>,
    document.getElementById('root')
);

// keep serviceWorker disabled for instant updates
serviceWorker.unregister();
